import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import config from '../../../../../config';
import { getAuthToken } from '../../../../utils/auth';
import useDidMount from '../../../hooks/use-didMount';

const putPriceSettings = async (
  publisherId,
  articleCategoryId,
  priceSettings
) => {
  console.log(
    'inside price settings',
    publisherId,
    articleCategoryId,
    priceSettings
  );
  const accessToken = getAuthToken();

  const payload = priceSettings;

  const response = await fetch(
    `${config.ApiBaseUrl}/publisher/${publisherId}/articleCategory/${articleCategoryId}/updatePriceSetting`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    }
  );

  const json = await response.json();

  console.log(json);

  const { message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return success;
};

const usePriceSettings = (price, tipJarPrice, categoryId, category) => {
  const didMount = useDidMount();

  const publisherId = useSelector((state) => state.user.publisher?.id);

  const [priceSettings, setPriceSettings] = useState({
    paywallPrice: price,
    tipJarPrice,
  });

  useEffect(() => {
    if (!didMount) {
      if (publisherId) {
        toast.promise(
          putPriceSettings(publisherId, categoryId, priceSettings),
          {
            loading: `setting ${category} price...`,
            success: `${category} price set!`,
            error: `Error while ${category} price!`,
          }
        );
      }
    }
  }, [priceSettings]);

  const handleTipJarChange = (tipJar) => {
    const tipJarTransformed = [];

    tipJar.forEach((key) => {
      tipJarTransformed.push(tipJar[key]);
    });
    // for (const key in tipJar) {
    //   tipJarTransformed.push(tipJar[key]);
    // }

    setPriceSettings((prevState) => ({
      ...prevState,
      tipJarPrice: tipJarTransformed,
    }));
  };

  const handlePaywallChange = (paywall) => {
    setPriceSettings((prevState) => ({ ...prevState, paywallPrice: paywall }));
  };

  return {
    priceSettings,
    handlePaywallChange,
    handleTipJarChange,
  };
};

export default usePriceSettings;
